// extracted by mini-css-extract-plugin
module.exports = {"checkbox-group":"_32bbee5fda--checkbox-group--dt66l","divider":"_32bbee5fda--divider--EAU6L"};